import { FC } from 'react';

import dashboardCampaignButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_campaign_button_click';
import { Button, VSpacing } from '@hh.ru/magritte-ui';
import { PlusOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { CampaignFrontendStatus } from 'store/models/campaignsDashboard';

const TrlKeys = {
    addBanner: 'BannersPage.addBanner',
};

interface AddBannerButtonProps {
    campaignId: number;
    campaignStatus: CampaignFrontendStatus;
}

export const AddBannerButton: FC<AddBannerButtonProps> = ({ campaignId, campaignStatus }) => {
    const trls = useTrls();

    if (campaignStatus === CampaignFrontendStatus.Archived) {
        return null;
    }

    const onClick = () => {
        dashboardCampaignButtonClick({ buttonName: 'campaign_add_banner', campaignId });
    };

    return (
        <>
            <Button
                mode="secondary"
                style="neutral"
                icon={<PlusOutlinedSize24 />}
                onClick={onClick}
                Element="a"
                href={`/new/campaign/${campaignId}/banner/`}
                data-qa="create-new-banner-button"
                stretched
                spaceBetween={false}
            >
                {trls(TrlKeys.addBanner)}
            </Button>
            <VSpacing default={24} />
        </>
    );
};
